<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="person"
    :header_text_short="$t('WorkpackageRework.Info.Contacts.Header').toUpperCase()"
    :header_text_long="$t('WorkpackageRework.Info.Contacts.Header').toUpperCase()"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
    >
    <template #body>
      <CollapsableCategory
        :value="$t('WorkpackageRework.Info.Contacts.Description')"
        :init_expanded="true"
        :color="workpackage_fg_hex"
      >
      <template #content="{is_collapsed}">
        <TransitionAccordion>
          <div
            v-if="!is_collapsed"
            >
            <DisableableInputField
              class="mt-2 mb-2"
              :label="$t('WorkpackageRework.Info.Contacts.Name')"
              :value="workpackage.contact_name"
              :is_disabled="!isEditMode"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @change="updateWorkpackageValue('contact_name', $event)"
            />
            <DisableableInputField
              class="mt-2 mb-2"
              :label="$t('WorkpackageRework.Info.Contacts.Email')"
              :value="workpackage.contact_email"
              :is_disabled="!isEditMode"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @change="updateWorkpackageValue('contact_email', $event)"
            />
            <DisableableInputField
              class="mt-2"
              :label="$t('WorkpackageRework.Info.Contacts.PhoneNumber')"
              :value="workpackage.contact_phone_number"
              :is_disabled="!isEditMode"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @change="updateWorkpackageValue('contact_phone_number', $event)"
            />
          </div>
        </TransitionAccordion>
      </template>
    </CollapsableCategory>
      <!-- <ContactPageContactList
        :roles="[
          {
            name: 'Craftsman',
            persons: []
          }
          ]"
        :has_lines="false"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      /> -->
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'

import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
// import ContactPageContactList from '@/modules/WorkPackageWIP/ContactPageContactList.module.vue';

import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';


  export default {
    components: {
      WorkPackageSubPageModule,
      // ContactPageContactList,
      CollapsableCategory,
      DisableableInputField,
      TransitionAccordion
    },
    mixins: [
      WorkPackageReworkMixin
    ],
    props: ['location', ],

    data: () => ({
    }),
    created() {
      this.loadData();
    },
    watch: {
      workpackage_id() {
        this.loadData();
      },
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarUpdate'
      ]),
      loadData() {
      }
    },
  }
</script>
